/* IntiWell : bloc d'achat (couleur, taille, lot panaché, galerie au survol, livraison estimée). */
(function(){
  function init(root){
    var q = function(s){ return root.querySelector(s); }, qa = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var fmt = function(n){ return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n); };
    var readJson = function(sel){ var el = q(sel); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } };
    var variants = readJson('[data-iw-variants]'), colors = readJson('[data-iw-colors]');
    var threshold = parseFloat(root.dataset.threshold) || 0, disc = parseFloat(root.dataset.sub) || 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sw = q('.iw-swatch[aria-pressed="true"]'), teinte = sw ? sw.dataset.name : '';
    var sizeBtns = qa('[data-iw-sizefield] .iw-size'), hasSizes = sizeBtns.length > 0;
    var szb = q('[data-iw-sizefield] .iw-size[aria-pressed="true"]'), size = szb ? szb.dataset.size : null;
    var idInput = q('[data-iw-id]'), form = q('[data-iw-form]'), toast = q('[data-iw-toast]');
    var swName = q('[data-iw-swatch-name]'), szName = q('[data-iw-size-name]'), sizePrompt = szName ? szName.textContent : '';
    var slides = q('[data-iw-slides]'), thumbs = qa('.iw-gallery__thumb'), peek = q('[data-iw-peek]'), peekImg = peek ? peek.querySelector('img') : null;
    var mix = q('[data-iw-mix]'), mixSame = q('[data-iw-mix-same]'), mixRows = q('[data-iw-mix-rows]'), mixSum = q('[data-iw-mix-sum]');
    var colorField = q('[data-iw-colorfield]'), sizeField = q('[data-iw-sizefield]'), sizeAlert = q('[data-iw-size-alert]');
    var colorList = qa('.iw-swatch').map(function(b){ return { n: b.dataset.name, hex: b.style.getPropertyValue('--c').trim() }; });
    var sizeList = sizeBtns.map(function(b){ return b.dataset.size; });
    var pieces = [], rowsFor = 0;
    /* note sous les tailles (26/10/2026) : tailles absentes ou épuisées dans la couleur choisie, et les couleurs qui les ont */
    var szNote = null;
    if (sizeField && hasSizes) { szNote = document.createElement('p'); szNote.className = 'iw-size-note'; szNote.hidden = true; szNote.style.cssText = 'margin:.5em 0 0;font-size:.85em;opacity:.8'; sizeField.appendChild(szNote); }
    /* produit à 3 options (couleur|taille|lot) : les variantes Lot ne servent qu'à lire les prix ; panier et disponibilités passent par les variantes « 1 pièce » */
    var opt3 = Object.keys(variants).some(function(k){ return k.split('|').length === 3; });

    /* ---------- variantes ---------- */
    function findVariant(c, s, pack){
      if (s) { var v = variants[c + '|' + s + '|' + pack]; if (v) return v; }
      if (variants[c + '|' + pack]) return variants[c + '|' + pack];
      for (var k in variants) { var a = k.split('|'); if (a[0] === c && a[a.length - 1] === pack) return variants[k]; }
      return null;
    }
    function packEl(){ return q('input[name="iw-pack"]:checked'); }
    /* une taille qui n'existe pas dans une couleur (ex. 4XL en noir) compte comme indisponible */
    function isOut(c, s, pv){ var vv = s ? variants[c + '|' + s + '|' + pv] : null; if (s && opt3 && !vv) return true; return !!vv && vv.available === false; }
    function uniq(a){ return a.filter(function(x, i){ return a.indexOf(x) === i; }); }
    function qtyOf(r){ return r ? (parseInt(r.dataset.qty, 10) || 1) : 1; }
    function onePack(){ var r = qa('input[name="iw-pack"]').filter(function(x){ return qtyOf(x) === 1; })[0]; return r ? r.value : null; }
    function inLot(){ return !!(mix && qtyOf(packEl()) > 1); }
    function sameSize(){ return !mixSame || mixSame.checked; }
    function availPack(){ var r = packEl(), one = onePack(); return opt3 && one ? one : (r ? r.value : ''); }
    function pieceSize(pc){ return sameSize() ? size : pc.s; }
    function shortSize(s){ return s ? String(s).replace(/\s*\(.*\)\s*$/, '') : ''; }
    function andList(a){ return a.join(', ').replace(/, ([^,]*)$/, ' et $1'); }
    function packPrice(pack){ var c = inLot() && pieces[0] ? pieces[0].c : teinte; var v = findVariant(c, size, pack.value); return v ? v.price / 100 : parseFloat(pack.dataset.price); }
    function uniform(){ for (var i = 1; i < pieces.length; i++) if (pieces[i].c !== pieces[0].c || pieceSize(pieces[i]) !== pieceSize(pieces[0])) return false; return true; }
    function composition(full){
      var counts = {}, order = [];
      pieces.forEach(function(pc){ var k = pc.c + (sameSize() ? '' : ' ' + (full ? (pc.s || '?') : shortSize(pc.s) || '?')); if (!counts[k]) { counts[k] = 0; order.push(k); } counts[k]++; });
      var txt = order.map(function(k){ return counts[k] + ' ' + k; }).join(', ');
      if (sameSize() && size) txt += ' · taille ' + (full ? size : shortSize(size));
      return txt;
    }

    /* ---------- prix, bouton, résumé ---------- */
    function update(){
      var pack = packEl(); if (!pack) return;
      refreshSizes();
      var plan = q('input[name="iw-plan"]:checked'), sub = plan && plan.value === 'sub', lot = inLot();
      var c0 = teinte, s0 = size;
      if (lot && pieces.length) { var okp = pieces.filter(function(pc){ return !isOut(pc.c, pieceSize(pc), availPack()); })[0] || pieces[0]; c0 = okp.c; s0 = pieceSize(okp); }
      var v = findVariant(c0, s0, pack.value), v1 = opt3 ? findVariant(c0, s0, onePack()) : v;   /* v : prix du format (étiquette) ; v1 : variante « 1 pièce », seule envoyée au panier */
      idInput.value = v1 && (s0 || !hasSizes) ? v1.id : '';
      qa('input[name="iw-pack"]').forEach(function(r){ var el = r.closest('.iw-opt, .iw-tile').querySelector('[data-iw-pack-price]'); if (el) el.textContent = fmt(packPrice(r)); });
      var base = packPrice(pack), total = sub ? Math.round(base * (100 - disc)) / 100 : base;
      var once = q('[data-iw-once]'), subp = q('[data-iw-subprice]'), subw = q('[data-iw-subwas]');
      if (once) once.textContent = fmt(base);
      if (subp) subp.textContent = fmt(Math.round(base * (100 - disc)) / 100);
      if (subw) subw.textContent = fmt(base);
      qa('[data-iw-total]').forEach(function(el){ el.textContent = fmt(total); });
      var cmp = v && v.compare ? v.compare / 100 : (parseFloat(pack.dataset.compare) || 0), ref = Math.max(cmp, sub ? base : 0);
      // Lot : pas de prix barré (le lot n'a jamais été vendu à la somme des pièces) ; la comparaison avec le prix à l'unité est écrite en clair.
      var pq = qtyOf(pack), one = qa('input[name="iw-pack"]').filter(function(r){ return qtyOf(r) === 1; })[0], unit = one ? packPrice(one) : 0;
      if (pq > 1) ref = sub ? base : 0;
      var un = q('[data-iw-unit]'), bz = q('[data-iw-basis]');
      if (un) { var uon = pq > 1 && unit > total / pq; un.hidden = !uon; un.innerHTML = uon ? 'soit <b>' + fmt(total / pq) + ' la pièce</b> au lieu de ' + fmt(unit) + ' à l’unité' : ''; }
      if (bz) { bz.hidden = !(unit > 0); bz.textContent = unit > 0 ? 'Économies calculées sur le prix à l’unité : ' + fmt(unit) + ' la pièce.' : ''; }
      var was = q('[data-iw-was]'), save = q('[data-iw-save]'), cw = q('[data-iw-cta-was]');
      if (was) was.textContent = ref > total ? fmt(ref) : '';
      if (save) save.textContent = ref > total ? '−' + Math.round((1 - total / ref) * 100) + ' %' : '';
      if (cw) cw.textContent = ref > total ? fmt(ref) : '';
      var n = qtyOf(pack), ss = q('[data-iw-sticky-sub]');
      var pk = q('[data-iw-pk]'); if (pk) { var pkt = n > 1 ? 'Lot de ' + n + ' pièces' : '1 pièce'; pk.querySelector('[data-iw-pk-txt]').textContent = pkt; pk.setAttribute('aria-label', 'Formule choisie : ' + pkt + '. Changer de formule'); pk.hidden = false; }
      if (ss) ss.textContent = lot ? pack.dataset.label + ' · ' + fmt(total) : [pack.dataset.label, teinte.toLowerCase(), size ? shortSize(size) : ''].filter(Boolean).join(' · ') + ' · ' + fmt(total);
      if (mixSum) mixSum.textContent = lot ? pack.dataset.label + ' : ' + composition(false) + ' · ' + fmt(total) + (n > 1 ? ' (' + fmt(total / n) + ' la pièce)' : '') : '';
      var st = q('[data-iw-ship-text]'), sb = q('[data-iw-ship-bar]');
      if (st && threshold > 0) {
        var left = threshold - total;
        st.innerHTML = left > 0 ? 'Plus que <b>' + fmt(left) + '</b> pour la livraison offerte' : '<b>Livraison offerte</b> incluse avec ce format';
        sb.style.width = Math.min(100, total / threshold * 100) + '%';
      }
      gpSync();
    }
    function refreshSizes(){
      var pack = packEl(); if (!pack) return;
      var lot = inLot(), pv = availPack();
      sizeBtns.forEach(function(b){
        var sv = b.dataset.size, who = lot ? uniq(pieces.filter(function(pc){ return isOut(pc.c, sv, pv); }).map(function(pc){ return pc.c; })) : (isOut(teinte, sv, pv) ? [teinte] : []);
        var out = who.length > 0;
        b.disabled = out; b.title = out ? (lot ? 'Épuisée en ' + who.join(' et ') : 'Épuisée') : '';
        b.setAttribute('aria-label', sv + (out ? (lot ? ', épuisée en ' + who.join(' et ') : ', épuisée') : ''));
        if (out && size === sv) { size = null; b.setAttribute('aria-pressed', 'false'); if (szName) szName.textContent = sizePrompt; }
      });
      if (szNote) {
        var cs = lot ? uniq(pieces.map(function(pc){ return pc.c; })) : [teinte];
        var outs = sizeList.filter(function(sv){ return cs.some(function(c){ return isOut(c, sv, pv); }); });
        var alt = colorList.map(function(x){ return x.n; }).filter(function(c){ return cs.indexOf(c) < 0 && outs.every(function(sv){ return !isOut(c, sv, pv); }); });
        var pl = outs.length > 1;
        szNote.hidden = !outs.length;
        szNote.textContent = outs.length ? 'Taille' + (pl ? 's ' : ' ') + andList(outs.map(shortSize)) + ' indisponible' + (pl ? 's' : '') + ' en ' + andList(cs).toLowerCase() + (alt.length ? ' : disponible' + (pl ? 's' : '') + ' en ' + andList(alt).toLowerCase() + '.' : '.') : '';
      }
      qa('.iw-swatch').forEach(function(b){
        var out = !lot && !!size && isOut(b.dataset.name, size, pv);
        b.classList.toggle('is-out', out); b.setAttribute('aria-label', b.dataset.name + (out ? ', épuisée en ' + shortSize(size) : ''));
      });
      if (mixRows && lot) qa('.iw-mix__row').forEach(function(li){
        var pc = pieces[+li.dataset.i]; if (!pc) return;
        li.querySelectorAll('.iw-mix__sizes .iw-size').forEach(function(b){ var out = isOut(pc.c, b.dataset.size, pv); b.disabled = out; b.setAttribute('aria-label', b.dataset.size + (out ? ', épuisée en ' + pc.c : '')); if (out && pc.s === b.dataset.size) pc.s = null; });
        paintRow(li);
      });
    }

    /* ---------- galerie : survol, couleur, vignettes ---------- */
    function visible(){
      if (!slides) return [];
      return Array.prototype.filter.call(slides.children, function(s){ return !s.hidden; }).sort(function(a, b){ return (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0); });
    }
    var thumbsBox = q('[data-iw-thumbs]'), dots = null;
    if (slides) { dots = document.createElement('div'); dots.className = 'iw-gallery__dots'; dots.setAttribute('aria-hidden', 'true'); slides.insertAdjacentElement('afterend', dots); }
    function renderDots(){
      if (!dots) return;
      var n = visible().length; dots.innerHTML = ''; dots.hidden = n < 2;
      for (var i = 0; i < n; i++) dots.appendChild(document.createElement('span'));
    }
    var gPrev = q('[data-iw-gprev]'), gNext = q('[data-iw-gnext]'), gCount = q('[data-iw-gcount]'), tUp = q('[data-iw-tup]'), tDown = q('[data-iw-tdown]');
    function curIndex(){ return slides ? Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)) : 0; }
    function syncMore(){
      if (!thumbsBox || !tUp || !tDown) return;
      var vert = thumbsBox.scrollHeight > thumbsBox.clientHeight + 1;
      tUp.hidden = !vert || thumbsBox.scrollTop < 4;
      tDown.hidden = !vert || thumbsBox.scrollTop + thumbsBox.clientHeight > thumbsBox.scrollHeight - 4;
    }
    function syncThumbs(){
      if (!slides) return;
      var vis = visible(), k0 = curIndex(), cur = vis[k0];
      Array.prototype.forEach.call(slides.children, function(s, k){
        if (!thumbs[k]) return;
        thumbs[k].setAttribute('aria-current', s === cur ? 'true' : 'false');
        if (s === cur && thumbsBox) {
          var t = thumbs[k];
          if (thumbsBox.scrollHeight > thumbsBox.clientHeight + 1) {
            var top = t.offsetTop, bot = top + t.offsetHeight;
            if (top < thumbsBox.scrollTop) thumbsBox.scrollTop = top; else if (bot > thumbsBox.scrollTop + thumbsBox.clientHeight) thumbsBox.scrollTop = bot - thumbsBox.clientHeight;
          } else if (thumbsBox.scrollWidth > thumbsBox.clientWidth + 1) {
            /* mobile : bande de miniatures horizontale */
            var l = t.offsetLeft, r = l + t.offsetWidth;
            if (l < thumbsBox.scrollLeft) thumbsBox.scrollLeft = l - 8; else if (r > thumbsBox.scrollLeft + thumbsBox.clientWidth) thumbsBox.scrollLeft = r - thumbsBox.clientWidth + 8;
          }
        }
      });
      if (dots) Array.prototype.forEach.call(dots.children, function(d, i){ d.classList.toggle('is-on', i === k0); });
      if (gCount) gCount.textContent = vis.length > 1 ? (k0 + 1) + ' / ' + vis.length : '';
      if (gPrev) gPrev.disabled = k0 <= 0;
      if (gNext) gNext.disabled = k0 >= vis.length - 1;
      /* une photo d'une autre couleur affiche son nom, avec un bouton pour la choisir */
      Array.prototype.forEach.call(slides.children, function(s){ var tg = s.querySelector('.iw-gallery__tag'); if (tg) tg.hidden = !(s === cur && s.classList.contains('is-other')); });
      syncMore();
    }
    var shown = '';
    function showColor(c){
      shown = c;
      if (!slides) return;
      /* Toutes les photos restent visibles, pour que la cliente voie qu'il en existe d'autres :
         d'abord celles de la couleur choisie, avec chaque photo sans couleur (montage explicatif…) remise à son rang d'origine
         (le montage placé en 3e reste 3e pour chaque couleur), puis les photos des autres couleurs. */
      var all = Array.prototype.slice.call(slides.children), seq = [], neutral = [], others = [];
      all.forEach(function(s, i){ var cs = s.dataset.colors || ''; if (!cs) neutral.push(i); else if (cs.split('|').indexOf(c) > -1) seq.push(i); else others.push(i); });
      if (seq.length) { neutral.forEach(function(i){ seq.splice(Math.min(i, seq.length), 0, i); }); seq = seq.concat(others); }
      else seq = all.map(function(s, i){ return i; });
      all.forEach(function(s, i){
        var ord = String(seq.indexOf(i));
        s.hidden = false; s.style.order = ord; s.classList.toggle('is-other', others.indexOf(i) > -1);
        if (thumbs[i]) { thumbs[i].hidden = false; thumbs[i].style.order = ord; thumbs[i].classList.toggle('is-other', others.indexOf(i) > -1); }
      });
      var info = colors[c], vis = visible(), idx = 0;
      if (info && info.i > -1) { var k = vis.indexOf(all[info.i]); if (k > -1) idx = k; }
      slides.style.scrollBehavior = 'auto'; slides.scrollLeft = idx * slides.clientWidth; slides.style.scrollBehavior = '';
      renderDots(); syncThumbs();
      var note = q('[data-iw-color-note]'); if (note) note.hidden = !!(info && info.src);
    }
    var peekWant = null;
    function peekOn(c){
      var info = colors[c]; if (!peek || !peekImg || !info || !info.src) return;
      peekWant = c;
      if (peekImg.getAttribute('src') !== info.src) { peekImg.sizes = '(min-width: 990px) 55vw, 100vw'; peekImg.srcset = info.srcset || ''; peekImg.src = info.src; }
      /* n'afficher l'aperçu qu'une fois la photo chargée : sinon un cadre vide passe devant la photo */
      if (peekImg.complete && peekImg.naturalWidth) peek.classList.add('is-on');
      else peekImg.onload = function(){ if (peekWant === c) peek.classList.add('is-on'); };
    }
    function peekOff(){ peekWant = null; if (peek) peek.classList.remove('is-on'); }
    var preloaded = false;
    function preload(){
      if (preloaded) return; preloaded = true;
      Object.keys(colors).forEach(function(c){ var i = colors[c]; if (!i.src) return; var im = new Image(); im.sizes = '(min-width: 990px) 55vw, 100vw'; if (i.srcset) im.srcset = i.srcset; im.src = i.src; if (i.thumb) { var t = new Image(); t.src = i.thumb; } });
    }
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      var idle = window.requestIdleCallback || function(f){ return setTimeout(f, 1200); };
      if (document.readyState === 'complete') idle(preload); else window.addEventListener('load', function(){ idle(preload); });
    }
    function goTo(t, smooth){ var k = visible().indexOf(slides.children[parseInt(t.dataset.index, 10)]); if (k > -1) slides.scrollTo({ left: slides.clientWidth * k, behavior: smooth && !reduce ? 'smooth' : 'auto' }); }
    function goStep(d){ if (!slides) return; var n = visible().length, k = Math.max(0, Math.min(n - 1, curIndex() + d)); slides.scrollTo({ left: slides.clientWidth * k, behavior: reduce ? 'auto' : 'smooth' }); }
    if (gPrev) gPrev.addEventListener('click', function(){ goStep(-1); });
    if (gNext) gNext.addEventListener('click', function(){ goStep(1); });
    if (tUp) tUp.addEventListener('click', function(){ thumbsBox.scrollBy({ top: -thumbsBox.clientHeight * 0.8, behavior: reduce ? 'auto' : 'smooth' }); });
    if (tDown) tDown.addEventListener('click', function(){ thumbsBox.scrollBy({ top: thumbsBox.clientHeight * 0.8, behavior: reduce ? 'auto' : 'smooth' }); });
    if (thumbsBox) { thumbsBox.addEventListener('scroll', syncMore, { passive: true }); window.addEventListener('resize', syncMore); }
    /* la vue de face de chaque couleur se charge tout de suite (survol des pastilles, bouton d'une autre couleur) */
    if (slides) Object.keys(colors).forEach(function(c){ var i = colors[c].i, s = i > -1 ? slides.children[i] : null, im = s ? s.querySelector('img') : null; if (im) im.loading = 'eager'; });
    var hoverThumbs = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 990px)');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ goTo(t, true); });
      /* comme sur Amazon : sur ordinateur, survoler une miniature affiche la photo */
      t.addEventListener('mouseenter', function(){ if (hoverThumbs && hoverThumbs.matches) goTo(t, false); });
    });
    if (slides) { slides.addEventListener('scroll', syncThumbs, { passive: true }); renderDots(); syncThumbs(); }

    /* ---------- sélection principale ---------- */
    function pickColor(name){
      var b = qa('.iw-swatch').filter(function(x){ return x.dataset.name === name; })[0]; if (!b) return false;
      qa('.iw-swatch').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      teinte = name; if (swName) swName.textContent = name;
      showColor(name); return true;
    }
    function pickSize(val){
      var b = sizeBtns.filter(function(x){ return x.dataset.size === val; })[0]; if (!b || b.disabled) return false;
      sizeBtns.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      size = val; if (szName) szName.textContent = val;
      if (sizeField) sizeField.classList.remove('is-alert'); if (sizeAlert) sizeAlert.hidden = true;
      return true;
    }
    function pickPack(val){ var r = qa('input[name="iw-pack"]').filter(function(x){ return x.value === val; })[0]; if (r) { r.checked = true; return true; } return false; }
    /* aperçu au survol : seulement sur les appareils qui survolent (sur téléphone, un toucher ne doit jamais devenir un survol) */
    var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);
    qa('.iw-swatch').forEach(function(b){
      if (canHover) b.addEventListener('mouseenter', function(){ preload(); peekOn(b.dataset.name); if (swName) swName.textContent = b.dataset.name; });
      if (canHover) b.addEventListener('mouseleave', function(){ peekOff(); if (swName) swName.textContent = teinte; });
      b.addEventListener('focus', function(){ if (b.matches(':focus-visible')) { peekOn(b.dataset.name); if (swName) swName.textContent = b.dataset.name; } });
      b.addEventListener('blur', function(){ peekOff(); if (swName) swName.textContent = teinte; });
      b.addEventListener('click', function(){ peekOff(); pickColor(b.dataset.name); pieces.forEach(function(pc){ pc.c = teinte; }); if (inLot()) buildRows(true); update(); });
    });
    sizeBtns.forEach(function(b){ b.addEventListener('click', function(){ if (pickSize(b.dataset.size)) update(); }); });
    /* bouton « Choisir cette couleur » posé sur une photo d'une autre couleur */
    qa('[data-iw-pick]').forEach(function(b){
      b.addEventListener('click', function(){
        var c = b.dataset.iwPick; peekOff();
        if (gpOn()) { if (gpApply(c)) gpShowPhoto(); return; }
        if (!pickColor(c)) { teinte = c; if (swName) swName.textContent = c; showColor(c); }
        pieces.forEach(function(pc){ pc.c = teinte; }); if (inLot()) buildRows(true); update();
      });
    });
    /* ---------- couleur sous la photo (téléphone et tablette, 23/10/2026) ----------
       Rangée de pastilles juste sous la grande photo (< 990 px). Elle écrit dans pieces[] par les mêmes chemins que
       la rangée principale (J 230) et les lignes du lot (J 292) : panier inchangé. */
    var gp = q('[data-iw-gpick]'), gpHead = q('[data-iw-gpick-head]'), gpVal = q('[data-iw-gpick-val]'), gpLink = q('[data-iw-gpick-link]'), gpNote = q('[data-iw-gpick-note]');
    var gpSws = gp ? Array.prototype.slice.call(gp.querySelectorAll('.iw-gpick__sw')) : [];
    var small = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: false };
    var focusK = -1, undo = null;   /* focusK : pièce montrée en grand (-1 = toutes) ; undo : mélange à rétablir */
    function gpOn(){ return !!gp && small.matches; }
    function setTxt(e, t){ if (e && e.textContent !== t) e.textContent = t; }
    function sameColor(){ for (var i = 1; i < pieces.length; i++) if (pieces[i].c !== pieces[0].c) return false; return true; }
    function colorCounts(){ var k = {}, o = []; pieces.forEach(function(pc){ if (!k[pc.c]) { k[pc.c] = 0; o.push(pc.c); } k[pc.c]++; }); return o.map(function(c){ return k[c] + ' ' + c; }).join(', '); }
    function stickTop(){ var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--iw-stick')); return isNaN(v) ? 64 : v - 16; }
    function photoShown(){ if (!slides) return 1; var r = slides.getBoundingClientRect(), t = Math.max(r.top, stickTop()), b = Math.min(r.bottom, window.innerHeight); return Math.max(0, b - t) / Math.max(1, r.height); }
    function gpShowPhoto(){   /* après un choix : la grande photo doit être visible */
      if (!gpOn() || !slides) return;
      if (photoShown() < 0.5) {
        var g = slides.getBoundingClientRect(), r = gp.querySelector('.iw-gpick__sws').getBoundingClientRect();
        var d = Math.max(g.top - stickTop(), r.bottom + 12 - window.innerHeight);   /* photo sous les barres, pastilles jamais sous l'écran */
        if (Math.abs(d) > 4) window.scrollTo({ top: Math.max(0, window.pageYOffset + d), behavior: reduce ? 'auto' : 'smooth' });
      } else if (!reduce && slides.animate) slides.animate([{ opacity: .5 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
    }
    function gpBlock(c){   /* taille déjà choisie dans laquelle cette couleur est épuisée, sinon null */
      var pv = availPack();
      if (!inLot()) return size && isOut(c, size, pv) ? size : null;
      var list = focusK >= 0 && pieces[focusK] ? [pieces[focusK]] : pieces;
      var bad = list.filter(function(pc){ return isOut(c, pieceSize(pc), pv); })[0];
      return bad ? pieceSize(bad) : null;
    }
    function gpApply(c){
      var lost = gpBlock(c);
      if (lost) { showToast(c + ' : épuisé en taille ' + shortSize(lost) + ' pour le moment.'); return false; }
      peekOff();
      if (inLot() && focusK >= 0 && pieces[focusK]) {               /* une seule pièce : même règle que J 292 */
        pieces[focusK].c = c; if (focusK === 0) teinte = c; undo = null; showColor(c);
        var li = mixRows && mixRows.children[focusK]; if (li) paintRow(li);
      } else {                                                     /* toutes les pièces : corps de J 230 */
        if (inLot() && !undo && !sameColor()) undo = { cs: pieces.map(function(pc){ return pc.c; }), shown: shown };
        if (!pickColor(c)) { teinte = c; if (swName) swName.textContent = c; showColor(c); }
        pieces.forEach(function(pc){ pc.c = teinte; });
        if (inLot()) buildRows(true);
      }
      update(); return true;
    }
    function gpZoom(i){   /* photo d'une ligne du lot touchée : cette pièce en grand ; la rangée du haut ne modifie plus qu'elle */
      if (!gpOn() || !pieces[i]) return;
      focusK = i; peekOff(); showColor(pieces[i].c); gpSync();
      var g = q('.iw-gallery'); if (g) g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      var f = gp.querySelector('.iw-gpick__sw[tabindex="0"]'); if (f) f.focus({ preventScroll: true });
    }
    function gpSync(){
      if (!gp) return;
      var lot = inLot(), n = pieces.length, same = sameColor();
      if (!lot || focusK >= n) focusK = -1;
      if (!lot || (undo && undo.cs.length !== n)) undo = null;
      var cur = !lot ? teinte : focusK >= 0 ? pieces[focusK].c : (same ? pieces[0].c : '');
      setTxt(gpHead, !lot ? 'Couleur' : focusK >= 0 ? 'Couleur de la pièce ' + (focusK + 1) : same ? 'Couleur des ' + n + ' pièces' : 'Les ' + n + ' pièces');
      setTxt(gpVal, cur || colorCounts());
      var tab = null;
      gpSws.forEach(function(b){
        var c = b.dataset.name, on = c === cur, lost = on ? null : gpBlock(c);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.classList.toggle('is-out', !!lost); b.setAttribute('aria-disabled', lost ? 'true' : 'false');
        b.setAttribute('aria-label', c + (lost ? ', épuisée en ' + shortSize(lost) : ''));
        if (on) tab = b;
      });
      tab = tab || gpSws.filter(function(b){ return b.getAttribute('aria-disabled') !== 'true'; })[0] || gpSws[0];
      gpSws.forEach(function(b){ b.tabIndex = b === tab ? 0 : -1; });
      var act = !lot ? '' : focusK >= 0 ? 'all' : undo ? 'undo' : 'mix';
      if (gpLink) { gpLink.hidden = !act; gpLink.dataset.act = act; setTxt(gpLink, act === 'all' ? 'Toutes les pièces' : act === 'undo' ? 'Revenir à mon mélange' : same ? 'Mélanger les couleurs' : 'Modifier pièce par pièce'); }
      setTxt(gpNote, cur && !(colors[cur] && colors[cur].src) ? 'Photos en préparation' : '');
    }
    if (gp) {
      gp.addEventListener('pointerdown', preload, { passive: true });   /* vignettes des lignes prêtes avant le premier changement */
      gp.addEventListener('click', function(e){
        var b = e.target.closest('.iw-gpick__sw'); if (!b) return;
        if (b.getAttribute('aria-checked') === 'true') { showColor(b.dataset.name); gpShowPhoto(); return; }
        if (gpApply(b.dataset.name)) gpShowPhoto();
      });
      gp.addEventListener('keydown', function(e){   /* comme J 299-306 */
        var b = e.target.closest('.iw-gpick__sw'); if (!b) return;
        var dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]; if (!dir) return;
        e.preventDefault();
        var k = gpSws.indexOf(b), nx = null;
        for (var t = 1; t < gpSws.length && !nx; t++) { var cand = gpSws[(k + dir * t + gpSws.length * t) % gpSws.length]; if (cand.getAttribute('aria-disabled') !== 'true') nx = cand; }
        if (nx) { nx.focus(); nx.click(); }
      });
      if (gpLink) gpLink.addEventListener('click', function(){
        var act = gpLink.dataset.act;
        if (act === 'all') { focusK = -1; gpSync(); return; }
        if (act === 'undo' && undo) {
          var u = undo; undo = null;
          if (u.cs.length === pieces.length) pieces.forEach(function(pc, i){ pc.c = u.cs[i]; });
          pickColor(pieces[0].c);                                    /* teinte suit la pièce 1 (règle de J 292) */
          if (u.shown && u.shown !== pieces[0].c) showColor(u.shown);  /* la photo d'avant */
          qa('.iw-mix__row').forEach(paintRow); update(); gpShowPhoto(); return;
        }
        if (mix && !mix.hidden) {
          mix.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          var f = mixRows && mixRows.querySelector('.iw-mix__sw[tabindex="0"]'); if (f) f.focus({ preventScroll: true });
        }
      });
    }


    /* ---------- lot : une ligne par pièce ---------- */
    function el(tag, cls, txt){ var e = document.createElement(tag); if (cls) e.className = cls; if (txt) e.textContent = txt; return e; }
    function paintRow(li){
      var pc = pieces[+li.dataset.i], info = colors[pc.c] || {}, th = li.querySelector('.iw-mix__thumb'), im = th.querySelector('img');
      th.style.setProperty('--c', (colorList.filter(function(x){ return x.n === pc.c; })[0] || {}).hex || '');
      if (info.thumb) { im.src = info.thumb; im.hidden = false; } else { im.removeAttribute('src'); im.hidden = true; }
      li.querySelector('.iw-mix__n span').textContent = ' · ' + pc.c;
      var ps = pieceSize(pc), pv = availPack();
      li.querySelectorAll('.iw-mix__sw').forEach(function(b){ var on = b.dataset.name === pc.c, out = !on && isOut(b.dataset.name, ps, pv); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; b.classList.toggle('is-out', out); b.setAttribute('aria-disabled', out ? 'true' : 'false'); b.setAttribute('aria-label', b.dataset.name + (out ? ', épuisée en ' + shortSize(ps) : '')); });
      li.querySelectorAll('.iw-size').forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.size === pc.s ? 'true' : 'false'); });
    }
    function buildRows(force){
      if (!mix || !mixRows) return;
      var n = qtyOf(packEl());
      mix.hidden = n < 2;
      if (colorField) colorField.hidden = n >= 2;
      var cnt = q('[data-iw-mix-count]'); if (cnt) cnt.textContent = n >= 2 ? '· ' + n + ' pièces' : '';
      while (pieces.length < n) pieces.push({ c: teinte, s: size });
      pieces.length = Math.max(n, 0);
      if (n < 2) { mixRows.innerHTML = ''; rowsFor = 0; qa('.iw-swatch').forEach(function(x){ x.setAttribute('aria-pressed', x.dataset.name === teinte ? 'true' : 'false'); }); if (swName) swName.textContent = teinte; return; }
      mixRows.hidden = false;
      if (rowsFor === n && !force) { qa('.iw-mix__row').forEach(paintRow); syncSizeRows(); return; }
      mixRows.innerHTML = ''; rowsFor = n;
      pieces.forEach(function(pc, i){
        var li = el('li', 'iw-mix__row'); li.dataset.i = i;
        var th = el('span', 'iw-mix__thumb'), im = el('img'); im.alt = ''; im.width = 52; im.height = 52; im.decoding = 'async'; th.appendChild(im);
        if (gp) { var zb = el('button', 'iw-mix__zoom'); zb.type = 'button'; zb.setAttribute('aria-label', 'Voir la pièce ' + (i + 1) + ' en grand'); th.appendChild(zb); }
        var lab = el('span', 'iw-mix__n', 'Pièce ' + (i + 1)); lab.appendChild(el('span'));
        var grp = el('div', 'iw-mix__colors'); grp.setAttribute('role', 'radiogroup'); grp.setAttribute('aria-label', 'Couleur de la pièce ' + (i + 1));
        colorList.forEach(function(cn){ var b = el('button', 'iw-mix__sw'); b.type = 'button'; b.dataset.name = cn.n; b.style.setProperty('--c', cn.hex); b.setAttribute('role', 'radio'); b.setAttribute('aria-label', cn.n); grp.appendChild(b); });
        var right = el('div'); right.appendChild(lab); right.appendChild(grp);
        li.appendChild(th); li.appendChild(right);
        if (sizeList.length) {
          var sz = el('div', 'iw-mix__sizes'); sz.setAttribute('role', 'group'); sz.setAttribute('aria-label', 'Taille de la pièce ' + (i + 1));
          sizeList.forEach(function(sv){ var b = el('button', 'iw-size', shortSize(sv)); b.type = 'button'; b.dataset.size = sv; b.setAttribute('aria-label', sv); b.setAttribute('aria-pressed', 'false'); sz.appendChild(b); });
          li.appendChild(sz);
        }
        mixRows.appendChild(li); paintRow(li);
      });
      syncSizeRows();
    }
    function syncSizeRows(){
      var same = sameSize();
      qa('.iw-mix__sizes').forEach(function(s){ s.hidden = same; });
      if (sizeField) sizeField.hidden = !same && inLot();
    }
    if (mixRows) {
      mixRows.addEventListener('click', function(e){
        var li = e.target.closest('.iw-mix__row'); if (!li) return;
        var pc = pieces[+li.dataset.i], b;
        if ((b = e.target.closest('.iw-mix__sw'))) { if (b.getAttribute('aria-disabled') === 'true') { showToast(b.dataset.name + ' : épuisé en taille ' + shortSize(pieceSize(pc)) + ' pour le moment.'); return; } pc.c = b.dataset.name; undo = null; focusK = -1; peekOff(); if (+li.dataset.i === 0) { teinte = pc.c; } showColor(pc.c); }
        else if ((b = e.target.closest('.iw-size'))) { if (b.disabled) return; pc.s = b.dataset.size; li.classList.remove('is-alert'); }
        else if ((b = e.target.closest('.iw-mix__zoom'))) { gpZoom(+li.dataset.i); return; }
        else return;
        paintRow(li); update();
      });
      mixRows.addEventListener('pointerdown', preload, { passive: true });
      if (canHover) mixRows.addEventListener('mouseover', function(e){ var b = e.target.closest('.iw-mix__sw'); if (b) { preload(); peekOn(b.dataset.name); } });
      if (canHover) mixRows.addEventListener('mouseout', function(e){ var b = e.target.closest('.iw-mix__sw'); if (b && !b.contains(e.relatedTarget)) peekOff(); });
      mixRows.addEventListener('keydown', function(e){
        var b = e.target.closest('.iw-mix__sw'); if (!b) return;
        var dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]; if (!dir) return;
        e.preventDefault();
        var all = Array.prototype.slice.call(b.parentNode.children), k = all.indexOf(b), nx = null;
        for (var t = 1; t < all.length && !nx; t++) { var cand = all[(k + dir * t + all.length * t) % all.length]; if (cand.getAttribute('aria-disabled') !== 'true') nx = cand; }
        if (nx) { nx.focus(); nx.click(); }
      });
    }
    if (mixSame) mixSame.addEventListener('change', function(){
      if (!mixSame.checked) pieces.forEach(function(pc){ if (!pc.s) pc.s = size; });
      syncSizeRows(); qa('.iw-mix__row').forEach(paintRow); update();
    });
    qa('input[name="iw-pack"]').forEach(function(r){ r.addEventListener('change', function(){
      var tile = gpOn() ? r.closest('.iw-tile') : null, y0 = tile ? tile.getBoundingClientRect().top : 0;   /* téléphone : la tuile touchée reste sous le doigt */
      undo = null; focusK = -1; buildRows(false); if (gpOn() && !inLot() && shown !== teinte) showColor(teinte); update();
      if (tile) { var dy = tile.getBoundingClientRect().top - y0; if (Math.abs(dy) > 1) window.scrollBy(0, dy); }   /* ligne « soit … la pièce » au-dessus : sans ancrage du défilement (Safari), on compense */
    }); });
    qa('input[name="iw-plan"]').forEach(function(r){ r.addEventListener('change', update); });

    /* ---------- guide des tailles ---------- */
    var dlg = q('[data-iw-dlg]'), gl = q('[data-iw-guide]');
    if (gl) gl.addEventListener('click', function(e){
      if (dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); return; }
      var d = document.getElementById('iw-guide'); if (d) { e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
    });
    if (dlg) dlg.addEventListener('click', function(e){ if (e.target === dlg || e.target.closest('[data-iw-dlg-close]')) dlg.close(); });

    /* ---------- envoi au panier ---------- */
    function showToast(msg){ toast.textContent = msg; toast.classList.add('is-on'); clearTimeout(showToast.t); showToast.t = setTimeout(function(){ toast.classList.remove('is-on'); }, 4200); }
    function askSize(){
      if (sizeAlert) sizeAlert.hidden = false;
      if (sizeField && !sizeField.hidden) {
        sizeField.classList.add('is-alert');
        sizeField.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        var f = sizeField.querySelector('.iw-size:not(:disabled)'); if (f) f.focus({ preventScroll: true });
      }
    }
    /* Tous les achats (1 pièce, lot uni ou panaché) : des variantes « 1 pièce », pièces identiques regroupées en une entrée (quantity),
       sans propriété de ligne. Le prix du lot est refait au panier par les remises automatiques de Shopify. */
    function cartLines(){
      if (inLot()) return pieces.map(function(pc){ return { c: pc.c, s: pieceSize(pc) }; });
      var a = [], n = qtyOf(packEl()); while (a.length < n) a.push({ c: teinte, s: size }); return a;   /* sans lignes de lot : n fois la pièce choisie */
    }
    function addPieces(){
      var one = onePack(), agg = {}, items = [], miss = false;
      if (opt3) cartLines().forEach(function(pc){ var v = one && pc.s ? variants[pc.c + '|' + pc.s + '|' + one] : null; if (v) agg[v.id] = (agg[v.id] || 0) + 1; else miss = true; });
      else if (idInput.value) agg[idInput.value] = 1;   /* produit sans option Lot : la variante choisie, comme avant */
      Object.keys(agg).forEach(function(id){ items.push({ id: +id, quantity: agg[id] }); });
      if (miss || !items.length) { showToast(root.dataset.demoMsg); return; }   /* une pièce introuvable : rien n'est ajouté */
      var btn = q('[data-iw-cta]'), fail = 'L’ajout au panier n’a pas abouti. Réessayez dans un instant.';
      if (btn.disabled) return; btn.disabled = true;
      fetch(root.dataset.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){
          if (r.ok) { window.location.href = root.dataset.cartUrl; return; }
          /* 422 (pièce épuisée, stock insuffisant) : Shopify a pu ajouter une partie des pièces. Message de Shopify, bouton laissé inactif,
             puis page panier : pas de second envoi possible depuis cette page. Un seul appel items[] : jamais d'ajout pièce par pièce. */
          return r.json().then(function(d){ return d; }, function(){ return null; }).then(function(d){
            if (r.status !== 422) throw new Error(r.status);
            showToast((d && typeof d.description === 'string' ? d.description : 'L’ajout au panier n’a pas abouti.') + ' Vérifiez votre panier.');
            setTimeout(function(){ window.location.href = root.dataset.cartUrl; }, 3000);
          });
        })
        .catch(function(){ btn.disabled = false; showToast(fail); });
    }
    form.addEventListener('submit', function(e){
      e.preventDefault();   /* jamais d'envoi natif : tout passe par addPieces() (/cart/add.js, variantes « 1 pièce ») */
      var lot = inLot();
      if (hasSizes) {
        if (lot && !sameSize()) {
          var miss = -1; pieces.forEach(function(pc, i){ if (miss < 0 && !pc.s) miss = i; });
          if (miss > -1) { e.preventDefault(); var li = mixRows.children[miss]; if (li) { li.classList.add('is-alert'); li.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); var f = li.querySelector('.iw-size:not(:disabled)'); if (f) f.focus({ preventScroll: true }); } showToast('Choisissez la taille de la pièce ' + (miss + 1) + '.'); return; }
        } else if (!size) { e.preventDefault(); askSize(); return; }
      }
      if (lot) {
        var pv = availPack(), bad = -1; pieces.forEach(function(pc, i){ if (bad < 0 && isOut(pc.c, pieceSize(pc), pv)) bad = i; });
        if (bad > -1) { e.preventDefault(); var lb = mixRows && mixRows.children[bad]; if (lb) { lb.classList.add('is-alert'); lb.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } showToast('Pièce ' + (bad + 1) + ' : coloris ' + pieces[bad].c + ' épuisé en taille ' + shortSize(pieceSize(pieces[bad])) + '. Choisissez une autre couleur ou taille.'); return; }
      }
      addPieces();
    });
    window.addEventListener('pageshow', function(e){ if (e.persisted) { var b = q('[data-iw-cta]'); if (b) b.disabled = false; } });   /* retour arrière depuis le panier : bouton actif */

    /* ---------- onglets compléments (démo) ---------- */
    qa('[data-iw-addon]').forEach(function(b){ b.addEventListener('click', function(){ showToast(root.dataset.demoMsg); }); });
    qa('.iw-tabs__btn').forEach(function(b){
      b.addEventListener('click', function(){
        qa('.iw-tabs__btn').forEach(function(x){ x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        qa('.iw-addons__panel').forEach(function(pn){ pn.hidden = pn.dataset.panel !== b.dataset.tab; });
      });
    });

    /* ---------- barre d'achat collante ---------- */
    var pkBtn = q('[data-iw-pk]');   /* rappel de la formule à côté du prix : descend jusqu’aux lots, la formule choisie prend le focus */
    if (pkBtn) pkBtn.addEventListener('click', function(){
      var t = q('.iw-offers') || q('.iw-field--packs'); if (!t) return;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - stickTop() - 24, behavior: reduce ? 'auto' : 'smooth' });
      var r = packEl(); if (r) r.focus({ preventScroll: true });
    });
    var sticky = q('[data-iw-sticky]'), cta = q('[data-iw-cta]');
    if ('IntersectionObserver' in window && sticky && cta) {
      new IntersectionObserver(function(entries){
        var e = entries[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        q('[data-iw-sticky-btn]').tabIndex = on ? 0 : -1;
      }).observe(cta);
      q('[data-iw-sticky-btn]').addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(); else cta.click(); });
    }

    /* ---------- date de livraison estimée (jours ouvrés, hors week-ends) ---------- */
    var eta = q('[data-iw-eta]');
    if (eta) {
      var addBiz = function(n){ var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
      var df = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      eta.textContent = (eta.dataset.text || 'Commandé aujourd’hui, reçu entre le {min} et le {max}').replace('{min}', df.format(addBiz(parseInt(eta.dataset.min, 10) || 0))).replace('{max}', df.format(addBiz(parseInt(eta.dataset.max, 10) || 0)));
    }

    /* ---------- départ : couleur, taille et format depuis l'adresse (?variant=, ?couleur=, ?lot= nombre de pièces, sans taille imposée) ---------- */
    try {
      var sp = new URLSearchParams(window.location.search), vid = sp.get('variant'), col = sp.get('couleur'), lt = sp.get('lot');
      if (vid) { for (var k in variants) { if (String(variants[k].id) === vid) { var a = k.split('|'); col = a[0]; if (a.length === 3) { pickSize(a[1]); pickPack(a[2]); } else { pickPack(a[1]); } break; } } }
      if (col) pickColor(col);
      if (lt) { var rl = qa('input[name="iw-pack"]').filter(function(x){ return String(qtyOf(x)) === lt; })[0]; if (rl) rl.checked = true; }
    } catch (e) {}
    if (teinte) showColor(teinte);
    buildRows(true);
    update();
  }
  function boot(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-iw-buy]'), function(r){ if (r.dataset.iwReady) return; r.dataset.iwReady = '1'; init(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
